/*
 * IMPORTANT: This config is meant to grow and accomodate future layouts for pages like
 *  add-ons, build your own package, etc. Please contribute and evolve as necessary to build
 *  new experiences within the event app.
 *
 * If a layout / section option does not have a value, it is presumed to be false and will not display
 *
 * List of page types:
 * - Main: The event page for all GA / seatmaped experiences
 *  (TODO: should seated vs. GA events have different page types that are defined here?)
 * - VIP: Premium event page experience for all VIP classified event experiences
 *
 * List of possible section components: --> Please contribute to this list as we add new options
 * Desktop:
 * - LeftPanel (string): Container that reflects the name & contents of the component
 *  filling the left column section
 * - BYOTakeover (string): Animated container reflecting the name & contents of the component
 *  that appears on top of the LeftPanel section
 * - MainPanel (string): Container that reflects the name & contents of the component
 *  filling the main middle panel section
 * - RightPanel (string): Container that reflects the name & contents of the component
 *  filling the right column section
 * mWeb:
 * - ContentWindow (string): Container that reflects the name & contents
 * of the component filling the section just below the header and above the ContentScroll
 * - ContentScroll (string): Container that reflects the name & contents
 * of the component filling the section just below the ContentScroll container
 * - BYOTakeover (string): Container that reflects the name & contents
 * of the component that overtakes the entire user view upon selecting a ticket
 * - SplashScreen (string): Container that reflects the name & contents
 * of the component that appears on initial pageload and covers the entire user view
 */
export const LayoutConfig = {
  desktop: {
    Main: {
      LeftPanel: 'TicketList',
      BYOTakeover: 'BuildYourOrder',
      MainPanel: 'RoyalMap',
      RightPanel: 'ListingsFilter', // TBD if this stays with main event or is AB tested out
    },
    // TBD specific VIP component names
    VIP: {
      LeftPanel: 'TicketList',
      BYOTakeover: 'BuildYourOrder',
      MainPanel: null,
      RightPanel: null,
    },
  },
  phone: {
    Main: {
      ContentWindow: 'RoyalMap',
      ContentScroll: 'TicketList',
      BYOTakeover: 'BuildYourOrder',
      SplashScreen: 'ListingsFilter', // TBD if this stays with ongoing AB test on filters
    },
    // TBD specific VIP component names
    VIP: {
      ContentWindow: 'RoyalMap',
      ContentScroll: 'TicketList', // "VIPTicketList",
      BYOTakeover: 'BuildYourOrder',
      // Extra stage with compare that is in between ticketlist and BYO, build as extension of BYO?
      SplashScreen: 'ListingsFilter',
    },
  },
  default: {
    // Desktop centric
    LeftPanel: 'TicketList',
    BYOTakeover: 'BuildYourOrder',
    MainPanel: 'RoyalMap',
    RightPanel: 'ListingsFilter',
    // MWeb centric
    ContentWindow: 'RoyalMap',
    ContentScroll: 'TicketList',
    SplashScreen: 'ListingsFilter',
  },
};
